<template>
  <div id="isLoading">
    <div v-show="getIsLoadingStatus" class="IsLoadingBg">
      <div class="IsLoadingBox">
        <div class="img d-flex justify-content-center">
          <lottie-player
            src="https://assets7.lottiefiles.com/packages/lf20_xv0nzibg.json"
            background="transparent"
            speed="1"
            style="width: 300px; height: 300px"
            loop
            autoplay
          ></lottie-player>
        </div>
        <p @click="toggleOverFlow('auto')" class="text-center mt-4">Loading . . .</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import "@lottiefiles/lottie-player";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLoading = namespace("Loading");
@Component
export default class IsLoading extends Vue {
  @StoreLoading.Getter
  private getIsLoadingStatus!: boolean;

  @Watch("getIsLoadingStatus")
  getIsLoadingStatusChanged(newVal: boolean) {
    if (newVal) {
      this.toggleOverFlow("hidden");
    } else {
      this.toggleOverFlow("auto");
    }
  }

  public toggleOverFlow(overflowType: string) {
    const el = document.body;
    el.style.overflow = overflowType;
  }
}
</script>

<style lang="scss" scoped>
#isLoading {
  .IsLoadingBg {
    position: fixed;
    background: rgba(255, 255, 255, 0.808);
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 999;
    backdrop-filter: blur(5px);
  }
  .IsLoadingBox {
    padding: 20px;

    position: absolute;
    width: 350px;
    height: 350px;
    left: 50%;
    top: 50%;
    margin-top: -175px;
    margin-left: -175px;
    border-radius: 6px;
  }
}
</style>
